import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-developer-header',
  imports: [TranslatePipe],
  templateUrl: './developer-header.html',
  styleUrl: './developer-header.scss',
})
export class DeveloperHeader {}
